import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
export default function FragmentMark(props) {
  var WrapperElement = props.isInline ? 'span' : 'div';
  return /*#__PURE__*/React.createElement(WrapperElement, _extends({
    "data-localId": props.localId,
    "data-name": props.name,
    "data-mark-type": "fragment"
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
  }, props.dataAttributes), props.children);
}